module.exports = __webpack_public_path__ + "static/media/arrow.31a33b4b.svg";